import i18n from "i18next";
import { Alert } from "@mui/material";
import React from "react";

const messageMap: Record<string, string> = {
  "validation.field.required": "validation.field.required.manual.check.warning",
};

const specialValidationMessages = new Set(["diplomaHolder.personalId.validation.field.invalid"]);

const handleValidationErrors = (validationErrors) => {
  if (!Array.isArray(validationErrors)) return [];

  const displayErrors = validationErrors.map((e) => {
    const messageKey = `${e.pointer}.${e.message}`;

    if (messageMap[e.message]) {
      return messageMap[e.message];
    }

    if (specialValidationMessages.has(messageKey)) {
      return messageKey;
    }

    return e.message;
  });

  return Array.from(new Set(displayErrors.map((msg) => i18n.t(msg))));
};

const ValidationErrorsAlert = ({ validationErrors }) => {
  const errors = handleValidationErrors(validationErrors);

  if (!errors.length) return null;

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      <ul style={{ margin: 0, paddingLeft: "1.5rem" }}>
        {errors.map((err, i) => (
          <li key={i}>{err}</li>
        ))}
      </ul>
    </Alert>
  );
};

export default ValidationErrorsAlert;
